export default __webpack_public_path__ + "static/media/bottle_circles.6553a472.png";